export default {
  allDueDiligenceExemptions: (state) => state.dueDiligenceExemptions
}
